<template>
	<div class="login">
		<div class="login-inner">
			<form class="login-form" method="POST" @submit.prevent="login" autocomplete="off">
				<img src="@/assets/ceara-login.png" alt="Ceara" />
				<h2 class="login-form-title">ACCESO PAGOS ONLINE</h2>
				<label for="email" class="login-form-control">
					<input
						type="text"
						id="email"
						class="login-form-input"
						placeholder="USUARIO"
						autocomplete="off"
						v-model="username"
					/>
				</label>
				<label for="password" class="login-form-control">
					<input
						type="password"
						id="password"
						class="login-form-input"
						placeholder="CONTRASEÑA"
						autocomplete="off"
						v-model="password"
					/>
				</label>
				<button class="btn btn-orange btn-sm">INGRESAR</button>
			</form>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	export default {
		name: 'Login',

		data() {
			return {
				username: '',
				password: ''
			}
		},

		methods: {
			login() {
				this.$store
					.dispatch('LOGIN', this.$data)
					.then(() => this.$router.push({ path: '/', query: this.$route.query }))
					.catch(error => {
						swal.fire({ html: error.response.data.msg, icon: 'error' })

						console.log([error])
					})
			}
		}
	}
</script>
